import { useEffect, useState } from 'react'

function useAudioPlayer({ audioId, isReady = false }: { audioId: any; isReady: boolean }) {
  const [duration, setDuration] = useState(0)
  const [curTime, setCurTime] = useState(0)
  const [playing, setPlaying] = useState(false)
  const [clickedTime, setClickedTime] = useState()
  const audio = document.getElementById(audioId) as HTMLAudioElement

  const pauseAudio = () => audio?.pause()
  useEffect(() => {
    // state setters wrappers
    const setAudioData = () => {
      setDuration(audio?.duration)
      setCurTime(audio?.currentTime)
    }
    const setAudioTime = () => {
      setCurTime(audio?.currentTime)
    }

    // DOM listeners: update React state on DOM events
    // loadeddata가 재생 가능하다는 것을 보장하는 것이 아님에 주의
    audio?.addEventListener('loadeddata', setAudioData)
    audio?.addEventListener('timeupdate', setAudioTime)

    // React state listeners: update DOM on React state changes
    if (playing) {
      audio?.play().catch((err) => {
        console.log(err, 'error')
      })
    } else {
      audio?.pause()
    }

    if (clickedTime && clickedTime !== curTime) {
      audio.currentTime = clickedTime
      setClickedTime(null)
    }

    // effect cleanup
    return () => {
      audio?.removeEventListener('loadeddata', setAudioData)
      audio?.removeEventListener('timeupdate', setAudioTime)
    }
  }, [audio, clickedTime, curTime, playing])

  useEffect(() => {
    if (isReady && !!audio) {
      setDuration(audio?.duration)
      setCurTime(audio?.currentTime)
    }
  }, [isReady, audio])
  return {
    curTime,
    duration,
    playing,
    setPlaying,
    setClickedTime,
    pauseAudio,
  }
}

export default useAudioPlayer
